import type { FC } from 'react'

type Props = {
	text: string
}

export const CustomFontLabel: FC<Props> = ({ text }) => {
	const chars = text.split('')

	return (
		<div>
			{chars.map((char, i) => {
				const isNumber = !Number.isNaN(Number(char))
				const key = `${char}-${i}`
				return (
					<span key={key} style={isNumber ? { fontFeatureSettings: 'tnum' } : undefined}>
						{char}
					</span>
				)
			})}
		</div>
	)
}
